import type { VirtualNode } from './types';
import { VirtualNodeRenderer } from './VirtualNodeRenderer';

export type VirtualRendererOptions = {
  readonly allowedNodeTypes: readonly string[];
  readonly allowedAttributes: readonly string[];
};

type Props = {
  nodes: VirtualNode[];
  options: VirtualRendererOptions;
};

/**
 * Renders a virtual node tree with cascading options.
 */
export const VirtualRenderer = ({ nodes, options }: Props) => {
  return (
    <>
      {nodes.map((node: VirtualNode, index: number) => (
        <VirtualNodeRenderer key={index} node={node} options={options} />
      ))}
    </>
  );
};
